import { Image } from "antd";
import React from "react";

const ImageComponent = (props) => {
  return (
    <Image
      key={props?.key}
      width={props?.width}
      height={props?.height}
      src={`${props?.src}`}
      alt={props?.alt}
      preview={props?.isPreview}
      style={props?.style}
      className={`${props?.className}`}
      fallback={props?.fallback}
      onClick={props?.onClick}
    />
  );
};

export default ImageComponent;
